//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class LetterTagService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[LetterTag.Create]
	async create(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/aut/letter-tag/create', params || { });
	};

	//GeneratorFlag:[LetterTag.Delete]
	async delete(letterTagId, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		const params = {
			id:letterTagId
		}
	
		return await _server.delete('/aut/letter-tag/delete', {'params':params})
	};

	//GeneratorFlag:[LetterTag.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/aut/letter-tag/detail', {'params':params});
	};

	//GeneratorFlag:[LetterTag.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/aut/letter-tag/list', {'params':params});
	};

	//GeneratorFlag:[LetterTag.Update]
	async update(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/aut/letter-tag/update', params || { });
	};

//GeneratorFlag:[NewAction]
}